import Vue from 'vue'
import Vuex, { Store } from 'vuex'
// import { getUserInfo } from '../api/api'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    role: "",
    username:""
  },
  getters: {

    role: state => state.role,

    username: state => state.username,
    
  },
  mutations: {
    loginInfo2 (state, user) {
         state.role = user.role
         state.username = user.username

    },
//     subLogout (state) {
      
//     }
  },
//   actions: {
//     getMemberInfo (context) {
//       return new Promise((resolve, reject) => {
//         getUserInfo().then(res => {
//           // console.log(res.data)
//           context.commit('loginInfo2', res.data)
//           resolve('返回成功')
//         }).catch(err => {
//           reject(err)
//         })
//       })
//     }
//   }
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js